import { queryOptions } from '@tanstack/react-query'
import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'
import { getStateDetail, StateDetails } from './requests.ts'
import { GetStateByContryId, StateList } from '../common/requests.ts'

const StateQueryKeys = {
  details: (state_id?: number | null) => ['state_detail', state_id],
} as const
export class StateQueries {
  public static getStateById(
    stateId?: number | null,
    options: CustomQueryOptions<StateDetails> = {}
  ) {
    return queryOptions({
      queryKey: StateQueryKeys.details(stateId),
      queryFn: () => getStateDetail(stateId),
      ...options,
    })
  }

  public static getStateByCountry(
    countryId?: number,
    options: CustomQueryOptions<StateList> = {}
  ) {
    return queryOptions({
      queryKey: StateQueryKeys.details(countryId!),
      queryFn: () => GetStateByContryId(countryId),
      ...options,
    })
  }
}
